import type { ReactElement } from 'react';
import { Box } from '@mui/material';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import MailOutlined from '@mui/icons-material/MailOutlined';
import InventoryOutlined from '@mui/icons-material/InventoryOutlined';
import CalculateOutlined from '@mui/icons-material/CalculateOutlined';
import { toneColor, type Tone } from '../../components/tone';
import type { ApprovalKind } from './sample';

const KIND: Record<ApprovalKind, { icon: ReactElement; tone: Tone }> = {
  quotation: { icon: <DescriptionOutlined />, tone: 'error' },
  'agent-message': { icon: <MailOutlined />, tone: 'info' },
  booking: { icon: <InventoryOutlined />, tone: 'info' },
  'customer-message': { icon: <MailOutlined />, tone: 'success' },
  jcs: { icon: <CalculateOutlined />, tone: 'neutral' },
};

/** The tinted icon square that says what kind of card this is */
export function KindIcon({ kind, size = 44 }: { kind: ApprovalKind; size?: number }) {
  const { icon, tone } = KIND[kind];
  return (
    <Box
      sx={{
        display: 'grid',
        placeItems: 'center',
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: 2,
        color: toneColor(tone),
        bgcolor: `color-mix(in srgb, ${toneColor(tone)} 12%, transparent)`,
      }}
    >
      {icon}
    </Box>
  );
}
